var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verify-email"},[(_vm.isDN)?_c('RegisterEmail'):_c('NhstRegistration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }